<template>
    <div>
        <div v-if="isLogin" class="sm:hidden bg-white py-2 rounded-full flex justify-between items-center" @click="goToProfile()">
            <div class="flex items-center">
                <div class="pl-2 mr-3">
                    <img v-if="userLogin.profileImageUrl" class="w-8 rounded-full" :src="userLogin.profileImageUrl">
                    <img v-else class="w-8 rounded-full" src="@/assets/icon/profile-icon.png" />
                </div>
                <div class="text-a-blue-1c3e95 text-18">
                    {{ userLogin.firstname }}
                </div>
                <!-- <template v-if="userLogin.profileImageUrl">
                    <div class="w-8 h-8 bg-a-blue-1c3e95 rounded-full overflow-hidden mx-2">
                        <img v-if="userLogin.profileImageUrl" :src="userLogin.profileImageUrl">
                    </div>
                </template>
                <template v-else>
                    <div class="w-8 h-8 mx-2">
                        <img class="w-full" src="@/assets/icon/profile-icon.png" />
                    </div>
                </template>
                <div class="text-a-blue-1c3e95 text-18 pt-2px">
                    {{ userLogin.firstname }}
                </div> -->
            </div>
            <div class="flex text-18 text-a-blue-1c3e95 mx-2">
                <div>{{lbl.topbar.coin}}</div>
                <div class="px-1">{{ FilterNumberFormat(userPoint) }}</div>
                <div><img class="w-5 icon-coin inline-block" src="@/assets/icon/coin-point.png"></div>
            </div>
        </div>
        <div v-else class="sm:hidden bg-white py-2 rounded-full flex justify-center items-center" @click="clickLogin()">
            <div>
                <img class="icon-profile-size" src="../../../assets/icon/icon-user-login.png">
            </div>
            <div class="text-18 text-a-blue-1c3e95 ml-3">
                {{lbl.login.register_login}}
            </div>
        </div>
    </div>
</template>
<script>
import AuthStatusMixin from '@/mixin/AuthStatusMixin';
import Account from '@/helper/AccountHelper.js';
import ConfigManager from '@/config/ConfigManager.js';
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: 'LoginMobile',
    mixins: [AuthStatusMixin, LocaleMixin],
    props: {
        modalController: Object,
    },
    data: function(){
        return {
            userLogin: {
                profileImageUrl: null,
                firstname: null,
                point: 0
            }
        }
    },
    methods: {
        //from AuthStatusMixin
        onAccountInit: async function(){
            this.modalController.loadingModal.show();
            let token = await Account.getToken();
            let currentTime = new Date().getTime();
            let cacheUser = Account.getCacheUser();
            console.log(cacheUser);
            if(this.profile){
                if(cacheUser.channel == 'line' && cacheUser.line){
                    this.userLogin.profileImageUrl = cacheUser.line.pictureUrl + `?time=${currentTime}`
                } else{
                    this.userLogin.profileImageUrl = await ConfigManager.getApiUrl() +
                        `/profile/${this.profile.userId}/picture?type=large&token=${token}&time=${currentTime}`;
                }
                this.userLogin.firstname = await this.profile.firstName
                this.userLogin.point = await this.profile.updated_points.points
            }
            this.modalController.loadingModal.hide();
        },
        clickLogin: function() {
            this.modalController.loginModal.show();
        },
        goToProfile: function(){
            this.$router.push('/profile')
        }
    },
}
</script>
<style lang="scss" scoped>
    .icon-profile-size {
        width: 26px;
    }
    .circle-user-image{
        border-top: 1px solid #1c3e95;
        border-bottom: 1px solid #fff;
        border-radius: 50%;
        left: 15px;
        top: -2.5rem;
    }
</style>
